module.exports = __webpack_public_path__ + "media/images/menu/taurus-7a199891433ad2a582f10921bb420670.jpg";